import { TraversalRuleType } from "utils/constants";
import ContactDetails from "components/ContactDetails/ContactDetails";

export function GetLockedContentModalData(learner, contactNumber, contactEmail) {
  const modalContent =
    learner ? (
      <div>
        <p>This module is part of a package you don't have access to. Please contact your company's ucSKILLS Admin to access this content.</p>
      </div>
		) : (
      <div>
        <p>This module is part of a package you don't have access to. Contact us to ask about getting access for your organisation on:</p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ContactDetails number={contactNumber} email={contactEmail} />
        </div>
      </div>
		);
	return {
		title: "Unlock Modules",
		content: modalContent
	};
};

export function GetLockedLearningJourneyModalData(ruleType) {
	const modalContentVerb = ruleType === TraversalRuleType.EnableAfterPrevious ? "previous" : "first";
	const modalContent = (
		<div>
			<p>To unlock this content, please complete the {modalContentVerb} submodule.</p>
		</div>
	);
	return {
		title: "Locked Submodule",
		content: modalContent
	};
};